import { parseDateValue } from 'shared/lib/format';
import classNames from 'classnames';
import { MDPreview } from 'shared/ui/Textarea/MDPreview';

const getMonthAndYear = (date: string) => new Date(date).toLocaleString('en-US', { month: 'long', year: 'numeric' });
const getFormattedDate = (date: string) => parseDateValue(date, 'withPeriod');

export interface NoteProps {
  actor: string;
  note: string;
  createdAt: string;
  showHeader?: boolean;
  showDate?: boolean;
  lineNumToTruncate?: number;
  className?: string;
}

export function Note(props: NoteProps) {
  const { actor, note, createdAt, showHeader = true, showDate = true, lineNumToTruncate = 0, className = '' } = props;

  return (
    <div className={classNames('text-sm', className)}>
      {showHeader && (
        <div className="flex flex-col items-center border-b border-slate-100">
          <div className="relative top-1 bg-white px-3 text-xs text-slate-400">{getMonthAndYear(createdAt)}</div>
        </div>
      )}
      <div className={`line-clamp-${lineNumToTruncate} mb-1 mt-4 text-sm`}>
        <span className="font-bold">{actor}&nbsp;</span>
        <MDPreview
          value={note}
          inlineStyle={{ fontSize: 14 }}
        />
      </div>
      {showDate && <div className="text-xs leading-[20px] text-slate-600">{getFormattedDate(createdAt)}</div>}
    </div>
  );
}
